// Content Moderation Component
import React, { useState } from 'react';
import { useCampaign } from '../../context/CampaignContext';

const ContentModeration = ({ campaign, onClose }) => {
  const { approveModeration, rejectModeration } = useCampaign();
  const [loading, setLoading] = useState(false);
  const [selectedFlags, setSelectedFlags] = useState([]);
  const [notes, setNotes] = useState('');

  const flags = [
    { id: 'inappropriate-content', label: 'เนื้อหาไม่เหมาะสม' },
    { id: 'copyright-issue', label: 'ปัญหาลิขสิทธิ์' },
    { id: 'low-quality-image', label: 'ภาพคุณภาพต่ำ' },
    { id: 'misleading-information', label: 'ข้อมูลที่ทำให้เข้าใจผิด' },
    { id: 'other', label: 'อื่นๆ' }
  ];

  const toggleFlag = (flagId) => {
    setSelectedFlags(prev => 
      prev.includes(flagId)
        ? prev.filter(id => id !== flagId)
        : [...prev, flagId]
    );
  };

  const handleApprove = async () => {
    if (!window.confirm('ยืนยันการอนุมัติเนื้อหา?')) return;

    setLoading(true);
    try {
      await approveModeration(campaign.id);
      alert('อนุมัติเนื้อหาสำเร็จ');
      // Close modal and reload
      if (onClose) {
        onClose();
      }
    } catch (error) {
      console.error('Error approving moderation:', error);
      alert('เกิดข้อผิดพลาด: ' + error.message);
      setLoading(false);
    }
  };

  const handleReject = async () => {
    if (selectedFlags.length === 0) {
      alert('กรุณาเลือกเหตุผลในการปฏิเสธ');
      return;
    }

    if (!window.confirm('ยืนยันการปฏิเสธเนื้อหา?')) return;

    setLoading(true);
    try {
      await rejectModeration(campaign.id, selectedFlags, notes);
      alert('ปฏิเสธเนื้อหาสำเร็จ');
      if (onClose) onClose();
    } catch (error) {
      console.error('Error rejecting moderation:', error);
      alert('เกิดข้อผิดพลาด: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg max-w-2xl">
      <h2 className="text-xl font-bold mb-4">ตรวจสอบเนื้อหา</h2>
      
      <div className="mb-4">
        <div className="text-sm text-gray-600 mb-2">ชื่อ Campaign:</div>
        <div className="font-medium">{campaign.name?.th || campaign.name?.en || 'ไม่มีชื่อ'}</div>
      </div>

      {/* Banner Preview */}
      {campaign.banner?.desktop?.th?.imageUrl && (
        <div className="mb-4">
          <div className="text-sm text-gray-600 mb-2">Banner Preview:</div>
          <img
            src={campaign.banner.desktop.th.imageUrl}
            alt="Banner"
            className="w-full h-48 object-cover rounded-lg border"
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/800x200?text=Banner+Preview';
            }}
          />
        </div>
      )}

      {/* Flags */}
      <div className="mb-4">
        <div className="text-sm font-medium text-gray-700 mb-2">เหตุผลในการปฏิเสธ (ถ้าต้องการปฏิเสธ):</div>
        <div className="space-y-2">
          {flags.map(flag => (
            <label key={flag.id} className="flex items-center space-x-2 cursor-pointer">
              <input
                type="checkbox"
                checked={selectedFlags.includes(flag.id)}
                onChange={() => toggleFlag(flag.id)}
                className="rounded"
              />
              <span>{flag.label}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Notes */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          หมายเหตุเพิ่มเติม:
        </label>
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
          rows="3"
          placeholder="ระบุหมายเหตุ..."
        />
      </div>

      {/* Actions */}
      <div className="flex justify-end space-x-4">
        <button
          onClick={onClose}
          className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
        >
          ยกเลิก
        </button>
        <button
          onClick={handleReject}
          disabled={loading || selectedFlags.length === 0}
          className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50"
        >
          {loading ? 'กำลังดำเนินการ...' : 'ปฏิเสธ'}
        </button>
        <button
          onClick={handleApprove}
          disabled={loading}
          className="px-6 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 disabled:opacity-50"
        >
          {loading ? 'กำลังดำเนินการ...' : 'อนุมัติ'}
        </button>
      </div>
    </div>
  );
};

export default ContentModeration;

